import { render } from "./UpdateOldAccount.vue?vue&type=template&id=01260560&scoped=true"
import script from "./UpdateOldAccount.vue?vue&type=script&lang=js"
export * from "./UpdateOldAccount.vue?vue&type=script&lang=js"

import "./UpdateOldAccount.vue?vue&type=style&index=0&id=01260560&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01260560"]])

export default __exports__